// PresentationsAboutServiceProvider.tsx
import { getAll, getOne } from '../services/CRUDServiceProvider';
import { PresentationLink } from '../types/presentationLink';
import { PaginatedResponse } from '../types/pagination';
import { Translated } from '../types/translated';
import { PaginationRequest } from '../types/pagination';

let presentations_url_path = 'presentations';
let about_url_path = 'about';

export interface Presentation {
    title: Translated;
    description: Translated;
    slug: string;
    status: string;
    about_page: boolean;
    presentation_video_links?: PresentationLink[];
};

export const getAllPresentations = async (pagination: PaginationRequest): Promise<PaginatedResponse<Presentation>> => {
    //console.log(token);
    console.log(presentations_url_path);
    try {
        const response = await getAll<any>(presentations_url_path, pagination, undefined);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getPresentation = async (slug: string): Promise<Presentation> => {
    //console.log(token);
    console.log(presentations_url_path);
    try {
        const response = await getOne<any>(presentations_url_path, slug, undefined, undefined);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAllAbouts = async (pagination: PaginationRequest): Promise<PaginatedResponse<Presentation>> => {
    //console.log(token);
    console.log(about_url_path);
    try {
        const response = await getAll<any>(about_url_path, pagination, undefined);
        return response.data;
    } catch (error) {
        throw error;
    }
};
